/* eslint-disable parog-web/no-glint-expect-error-directive */
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import dayjs from 'dayjs';
import { validateDate } from 'ember-changeset-validations/validators';
import BaseMedicalHistoryFormComponent from 'parog-web/components/medical-history/abstract/base-edition-form';
import MedicalHistoryBaseEditionForm from './base-edition-form';
import HepatoGenericDiagnostic from './hepato/hepato-generic/diagnostic-fields';
import HepatoTransplantDiagnostic from './hepato/transplant/diagnostic-fields';
import HepatoTransplantPathology from './hepato/transplant/pathology-fields';

const PathologyFields = {
  transplant: HepatoTransplantPathology
};

const DiagnosticFields = {
  'hepato-generic': HepatoGenericDiagnostic,
  transplant: HepatoTransplantDiagnostic
};

export default class MedicalHistoryFormComponent extends BaseMedicalHistoryFormComponent {
  override journalEventProperties = [
    ...this.sharedProperties,
    ...this.hepaticPathologyProperties
  ];

  get diagnostic(): TemplateOnlyComponent {
    return DiagnosticFields[this.patho ?? ''];
  }

  get hepaticPathologyProperties(): string[] {
    return [
      'transplantDate',
      'transplantRank',
      'transplantedOrgan',
      'underlyingDisease',
      'cytomegalovirusStatus'
    ];
  }

  get pathology(): TemplateOnlyComponent {
    return PathologyFields[this.patho ?? ''];
  }

  override get validations(): Record<string, unknown> {
    return {
      transplantDate: [
        validateDate({
          allowBlank: true,
          message:
            'Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date',
          onOrAfter: new Date('01/01/1900')
        }),
        validateDate({
          allowBlank: true,
          message:
            'Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date',
          onOrBefore: dayjs().endOf('day').toDate()
        })
      ]
    };
  }

  override retrieveModel(): Record<string, unknown> {
    const model = super.retrieveModel();
    if (!this.isLoadedFromJe) {
      model.transplantedOrgan = 'liver';
    }

    return model;
  }

  <template>
    <MedicalHistoryBaseEditionForm
      {{! @glint-expect-error }}
      @forcComponent={{this}}
      @patient={{@patient}}
      as |mh|
    >
      <mh.FurSection />
      <mh.FurDetailsSection @diagnostic={{this.diagnostic}} />
      <mh.ComorbiditiesAllergiesSection />
      <mh.PathologySection @pathology={{this.pathology}} />
      <mh.VaccinesSection />
      <mh.CommentsSection />
    </MedicalHistoryBaseEditionForm>
  </template>
}
